import { connect } from 'react-redux';
import { goBack as goBackAction, push as pushAction } from 'react-router-redux';
import { fetchSpeakerDetails } from '../Speakers/actions/speakersActions';
import SpeakerDetails from './components/SpeakerDetails';

export const mapStateToProps = (state, props) => {
    const speaker = state.speakers.speakersById[props.match.params.id];
    const talksOfSpeaker = speaker ? speaker.talks : [];

    const talks = [];
    talksOfSpeaker.forEach(talkId => {
        if (state.program.talksById[talkId]) {
            talks.push(state.program.talksById[talkId]);
        }
    });

    const details = {
        ...speaker,
        talks
    };

    return {
        details,
        speakersById: state.speakers.speakersById,
        fetchingSpeakers: state.speakers.fetchingSpeakers
    };
};

export const mapActionCreators = {
    goBackAction,
    fetchSpeakerDetails,
    pushAction
};

export default connect(
    mapStateToProps,
    mapActionCreators
)(SpeakerDetails);
